let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j6SeM")).then(() => parcelRequire('3xy6E'));